// removed by extract-text-webpack-plugin
module.exports = {"Toolbar":"Toolbar__Toolbar__2hkfg","Logo":"Toolbar__Logo__24rue","DesctopOnly":"Toolbar__DesctopOnly__1Ma74"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/Toolbar/Toolbar.css
// module id = 42
// module chunks = 0